import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { apiKeyHeader } from "../../../configs/ApiKeys";
import { BASE_URL } from "../../../configs/WebServiceUrl";

// const API_BASE_URL = "http://localhost:5010/school";
const API_BASE_URL = "https://web1024.docmaster.in:5010/school";

export const fetchQuizzes = createAsyncThunk(
  "quiz/fetchQuizzes",
  async ({ type }, { rejectWithValue }) => {
    try {
      const res = await axios.get(`${API_BASE_URL}/quizzes`, {
        headers: apiKeyHeader(),
        params: { type },
      });
      return res.data;
    } catch (err) {
      console.error(err);
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const getQuizParticipants = createAsyncThunk(
  "quiz/getQuizParticipants",
  async ({ quiz_id }, { rejectWithValue }) => {
    try {
      const res = await axios.get(
        `${API_BASE_URL}/quiz-participants/${quiz_id}`,
        {
          headers: apiKeyHeader(),
        }
      );
      return res.data;
    } catch (err) {
      console.error(err);
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
export const fetchLiveQuizParticipants = createAsyncThunk(
  "quiz/fetchLiveQuizParticipants",
  async ({ quiz_id }, { rejectWithValue }) => {
    try {
      const res = await axios.get(
        `${API_BASE_URL}/live-quiz-participants/${quiz_id}`,
        { headers: apiKeyHeader() }
      );
      return res.data;
    } catch (err) {
      console.error(err);
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
export const fetchLeaderboard = createAsyncThunk(
  "quiz/fetchLeaderboard",
  async ({ quiz_id }, { rejectWithValue }) => {
    try {
      const res = await axios.get(`${API_BASE_URL}/top-participants/${quiz_id}`, {
        headers: apiKeyHeader(),
      });
      return res.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const createStudent = createAsyncThunk(
  "students/createStudent",
  async (studentData, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/api/auth/create-student`,
        studentData,
        {
          headers: apiKeyHeader(),
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);
export const fetchOrgStudents = createAsyncThunk(
  "students/getStudents",
  async (school_id, { rejectWithValue }) => {
    try {
      const url = school_id
        ? `${BASE_URL}/api/auth/students?school_id=${school_id}`
        : `${BASE_URL}/api/auth/students`;
      const response = await axios.get(url, {
        headers: apiKeyHeader(),
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);
const quizSlice = createSlice({
  name: "quiz",
  initialState: {
    quizzes: [],
    participants: [],
    leaderboard: [],
    liveParticipants: [],
    loading: false,
    error: null,
    students: [],
  },
  reducers: {
    clearParticipants: (state) => {
      state.participants = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchQuizzes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchQuizzes.fulfilled, (state, action) => {
        state.loading = false;
        state.quizzes = action.payload || [];
      })
      .addCase(fetchQuizzes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getQuizParticipants.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getQuizParticipants.fulfilled, (state, action) => {
        state.loading = false;
        state.participants = action.payload || [];
      })
      .addCase(getQuizParticipants.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchLiveQuizParticipants.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLiveQuizParticipants.fulfilled, (state, action) => {
        state.loading = false;
        state.liveParticipants = action.payload;
      })
      .addCase(fetchLiveQuizParticipants.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchLeaderboard.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLeaderboard.fulfilled, (state, action) => {
        state.loading = false;
        state.leaderboard = action.payload.leaderboard;
      })
      .addCase(fetchLeaderboard.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createStudent.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createStudent.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(createStudent.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchOrgStudents.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchOrgStudents.fulfilled, (state, action) => {
        state.students = action.payload;
        state.loading = false;
      })
      .addCase(fetchOrgStudents.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearParticipants } = quizSlice.actions;
export default quizSlice.reducer;
